module.exports = __webpack_public_path__ + "img/logo-cer-03.22c321b6.png";